import { IDataProvider } from "@/store";
export interface INotification {
  id: string;
  type: string;
  message: string;
  readed: boolean;
  info: string | Record<string, unknown> | null;
}
export interface IProcessInfoNotification {
  count: number;
  templateId: string;
}
export interface INotificationState {
  count: number;
  countRevision: number;
  processInfoRevision: number;
  notification: INotification | null;
  notifications: INotification[];
  processInfoNotifications: IProcessInfoNotification[];
  dataProvider: IDataProvider<INotification>;
}

export const state: INotificationState = {
  count: 0,
  countRevision: 0,
  processInfoRevision: 0,
  notification: null,
  notifications: [],
  processInfoNotifications: [],
  dataProvider: {
    items: [],
    pager: {
      buttonsToShow: 3,
      currentPage: 1,
      endPage: 1,
      startPage: 1,
      totalPages: 1,
    },
  },
};
